import {connect, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import React, {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {
    CAlert,
    CButton,
    CCol,
    CForm,
    CFormSelect,
    CInputGroup,
    CInputGroupText,
    CNav,
    CNavItem, CNavLink,
    CRow, CTabContent, CTabPane
} from "@coreui/react";
import numeral from "numeral";
import {AgGridReact} from "ag-grid-react";
import * as api from "../../../api/api";
import {Loading} from "../../../components/common";
//import StoreListWhere from "../where/StoreListWhere";
import BrandListWhere from "../where/BrandListWhere";
import StoreDetail from "../store/StoreDetail";
import {currencyFormatter} from "../../../config/formatter";
import StoreCornerListWhere from "../where/StoreCornerListWhere";

import ProductPrice from "./ProductPrice";
import ProductExpire from "./ProductExpire";
import dayjs from "dayjs";


const ProductChain = (props) => {

    const {user} = useSelector((props) => props.account);

    const gridRef = useRef();
    const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({visible: false, message: ""});
    const [gridData, setGridData] = useState([]);
    const [activeKey, setActiveKey] = useState(1);
    const [searchForm, setSearchForm] = useState({
        deviceId: "전체",
        saleDt: dayjs()
    });


    useEffect(() => {
        if (props.selected.storeCd.length > 0) {
            // getStoreDevice();
        }
    }, [props.selected.storeCd]);


    /*여기부터 화면Grid Start*/
    return (
        <>
            <div style={containerStyle}>
                {error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
                <div className="d-grid gap-1 d-md-flex justify-content-between" style={{ marginBottom: 10 }}>
                    <h5>휴게소별 상품 관리</h5>
                </div>
                <CCol>
                    <CNav variant="tabs" role="tablist">
                        <CNavItem>
                            <CNavLink
                                active={activeKey === 1}
                                onClick={() => setActiveKey(1)}>휴게소별 상품가격 관리
                            </CNavLink>
                        </CNavItem>
                        <CNavItem>
                            <CNavLink
                                active={activeKey === 2}
                                onClick={() => setActiveKey(2)}>휴게소별 상품 판매시간 관리</CNavLink>
                        </CNavItem>

                    </CNav>
                    <CTabContent>
                        <CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 1}>
                            <div style={{height: 10}}/>
                            <ProductPrice />
                        </CTabPane>
                        <CTabPane role="tabpanel" aria-labelledby="basic-tab" visible={activeKey === 2}>
                            <div style={{height: 10}}/>
                            <ProductExpire />
                        </CTabPane>

                    </CTabContent>
                </CCol>
            </div>
        </>
    ); /*End return화면*/

}

const mapStateToProps = (state) => {
    const { account, store, selected } = state;
    return {
        account, store, selected
    };
};

export default connect(mapStateToProps, null)(ProductChain);